import { FeatureFlags } from '../../../shared/util/featureFlag';
import { genPwdMatchValidator, genPwdRulesValidator } from '../../../shared/util/pwdUtil';
import { checkEmailDomain, validateEmail } from '../../../shared/util/stringUtil';
import { ajaxFormOnSubmitWithControl } from '../../lib/ajax';
import { isFlagEnabledForView } from '../../lib/featureFlag';
import { showError, showSuccess } from '../../lib/userHelp/userHelpTools';
import { attr, getByClassFirst, getById, hide, onChange, onDomLoaded, onKeyUp, show } from '../../lib/util/html';

const helpDiv = getByClassFirst('lead');
const emailForm: HTMLInputElement = getById('addEmailInput');
const errorDiv: HTMLDivElement = getById('registerMessageDiv');
const userForm: HTMLFormElement = getById('registerUserForm');
const emailFormGroup: HTMLFormElement = getById('userEmailGroup');
const userDetails = getById('userDetails');
const submitFormBtn = getByClassFirst('saveButton');

const emailInput: HTMLFormElement = getById('addEmail');
const usernameInput: HTMLFormElement = getById('addUsername');
const firstNameForm: HTMLInputElement = getById('addFirstName');
const lastNameForm: HTMLInputElement = getById('addLastName');
const passwordForm: HTMLInputElement = getById('pwdInput');
const passwordConfirmForm: HTMLInputElement = getById('confirmInput');

onDomLoaded(async () => {
    const disabled = await isFlagEnabledForView(FeatureFlags.disableSelfRegistration);
    hide(getByClassFirst('message-notif'));
    hide(getByClassFirst('chat-btn-open'));
    hide(getByClassFirst('chat-box-client'));
    hide(getById('adminDM'));
    hide(submitFormBtn);
    getByClassFirst('cl-content').classList.remove('invisible');
    if (disabled) {
        getByClassFirst('selfRegistrationContent').hidden = true;
        getByClassFirst('selfRegistrationDisabled').hidden = false;
    }
    else {
        let email = '';

        if (passwordForm) {
            genPwdRulesValidator(passwordForm)();
            onChange(userForm, genPwdMatchValidator(passwordForm, passwordConfirmForm));
            onKeyUp(passwordForm, genPwdRulesValidator(passwordForm));
        }

        emailForm.oninput = function () {
            emailForm.value = emailForm.value.toLowerCase();
        };

        onChange(emailForm, () => {
            checkEmail();
        });

        ajaxFormOnSubmitWithControl(emailFormGroup, async () => {
            return checkEmail();
        }, async (err, exists) => {
            if (err) {
                showError(errorDiv, err.message ? err.message as string : 'Unable to complete request');
            }
            else {
                // Check that the email does not belong to an existing user
                if (!exists) {
                    email = emailForm.value;
                    helpDiv.innerHTML = 'Please enter your account details';
                    emailFormGroup.remove();
                    // Fill the immutable parts of the newSelfRegistration form with the given email
                    emailInput.value = email;
                    usernameInput.value = email;
                    attr(emailInput, 'readonly', 'true');
                    attr(usernameInput, 'readonly', 'true');
                    hide(errorDiv);
                    show(submitFormBtn);
                    show(userDetails);
                }
                else {
                    // If email is already in use, hyperlink to password reset
                    helpDiv.innerHTML = `An account with this address is already registered. Do you need to 
                    <a href='/user/forgot' style='text-decoration: underline'>
                    reset your password?</a>`;
                }
            }
        });

        if (userDetails) {
            ajaxFormOnSubmitWithControl(userForm, async () => {
                if (firstNameForm.value && lastNameForm.value && passwordForm.value && passwordConfirmForm.value && emailInput.value === email && usernameInput.value === email) {
                    if (passwordForm.value === passwordConfirmForm.value) {
                        return true;
                    }
                    else {
                        show(errorDiv);
                        errorDiv.innerHTML = `<div class="alert alert-warning text-center">Password mismatch!</div>`;
                        return false;
                    }
                }
                else if (emailInput.value !== email || usernameInput.value !== email) {
                    show(errorDiv);
                    errorDiv.innerHTML = `<div class="alert alert-warning text-center">Username and email must both match original email value</div>`;
                    return false;
                }
                else {
                    show(errorDiv);
                    errorDiv.innerHTML = `<div class="alert alert-warning text-center">Please fill out all fields</div>`;
                    return false;
                }
            }, (err, data) => {
                if (err) {
                    showError(errorDiv, err.message ? err.message as string : 'Unable to complete request');
                }
                else {
                    userForm.parentElement.hidden = true;
                    showSuccess(errorDiv, data.message);
                    helpDiv.innerHTML = 'Registration complete. Please check your email for a verification link';
                    hide(errorDiv);
                    hide(userDetails);
                }
            });
        }
    }
});

function checkEmail() {
    const formEmail = emailForm.value;
    if (validateEmail(formEmail) && checkEmailDomain(formEmail)) {
        emailForm.setCustomValidity('');
        return true;
    }
    else {
        emailForm.setCustomValidity(`Invalid email address`);
        return false;
    }
}
